import React, { type PropsWithChildren } from 'react';
import { Box, Grid, xcss, type GridProps } from '@atlaskit/primitives';

const defaultTemplateAreas = [
	'header-avatar header-author .',
	'header-avatar header-subtext header-subtext',
];

const Header = ({
	children,
	templateAreas = defaultTemplateAreas,
	templateRows = '1fr',
	templateColumns = '36px minmax(min-content, max-content) 1fr',
	gap,
	columnGap = 'space.100',
	rowGap,
	testId,
}: PropsWithChildren<GridProps>) => {
	return (
		<Box xcss={headerStyles}>
			<Grid
				templateAreas={templateAreas}
				templateRows={templateRows}
				templateColumns={templateColumns}
				columnGap={columnGap}
				rowGap={rowGap}
				gap={gap}
				testId={testId}
			>
				{children}
			</Grid>
		</Box>
	);
};
const headerStyles = xcss({
	gridArea: 'header',
});

export default Header;
